module.exports = __webpack_public_path__ + "static/secondary-0489b2d44653c5df7860b15a21aef6ec.png";